<!--
 * @Description: description
 * @Author: chenguobiao
 * @Date: 2021-07-12 19:49:30
 * @LastEditTime: 2022-02-22 21:37:13
 * @LastEditors: chenguobiao
-->
<template>
  <div class="banner">
    <img src="@/render/assets/images/home/banner.png">
    <div class="notice flex justify-center item-center">
      <div class="notice__content flex items-center">
        <div class="notice__icon">
          <img src="@/render/assets/images/home/notice.png">
        </div>
        <!-- <div class="notice__text">{{content}}</div> -->
        <marquee class="notice__content" :list="contentList || []"/>
      </div>
    </div>
  </div>
</template>

<script>
import Marquee from './Marquee.vue'
export default {
  props: ['noticeList'],
  components: {
    Marquee
  },
  computed: {
    contentList() {
      let list = null
      list = this.noticeList ? this.noticeList.map(notice => {
        return notice.content
      }) : []
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner {
    position: relative;
    height: val(300);
    overflow: hidden;
    .notice {
      position: absolute;
      bottom: 0;
      left: 0;
      right: 0;
      height: val(48);
      background: rgba(#000000, 0.5);
      &__content {
        width: val(1200);
        height: val(48);
        ::v-deep {
          .text {
            font-size: 16px;
            line-height: val(48);
            height: val(48);
            overflow: auto;
            color: #fff;
          }
        }
      }
      &__icon {
        width: val(29);
        height: val(24);
        margin-right: val(14);
      }
    }
  }
</style>
